import { ISource } from '@qodly/shared';

export function getDebuggerTabPath(threadId: number) {
  return `Debugger/${threadId}`;
}

export function getDebuggerTabName(threadId: number, source: ISource) {
  const sourceName = source.name?.replace(/\.(4dm|4qs)$/, '');
  return `#${threadId} ${sourceName}`;
}
